<!-- swap out some types if page is different -->
<div id="page-container" class="sidebar-o sidebar-inverse side-scroll page-header-fixed main-content-boxed" 
[ngClass]="(authService.currentUser.userSettings.navbarPinned===false) ?  'sidebar-mini' : ''"
>
  <app-navbar></app-navbar>
  <app-topbar></app-topbar>
  <app-container [layoutClasses]="'content'"></app-container>
  <app-footer></app-footer>

</div>



// WEBPACK FOOTER //
// ./client/app/core/layout/secure/layouts/normal/layout.component.html